var openNewTabForExternalLink = function() {
    $('a').each(function(){
        if (this.href.indexOf(location.hostname) === -1 && this.href != "javascript:void(0);") { $(this).attr('target', '_blank'); }
    });
};

jQuery(document).ready(function($){
    openNewTabForExternalLink();
});